<div class="sliderContainer" [style.height]="bannerHeight" [style.width]="bannerWidth" *ngIf="sliderArray.length > 0">
  <div class="img-container" *ngFor="let i of sliderArray; let select = index;" [style.height]="bannerHeight" [style.width]="bannerWidth" [class.clickable]="i.link && i.link !== ''"
       [ngClass]="{'selected': select == selectedIndex}" (click)="selectBanner($event, i.type, i.link)">
    <img src="{{i.url}}" alt="{{i.link}}">
  </div>
</div>
